<template>
    <div>
        <v-app-bar :userInfo="userInfo" flat color="white" height="72" class="px-3" fixed app
            ><h2 class="page-title">Merchants</h2>

            <v-btn v-if="isPermitted(userInfo.permissions, 'merchants-store')" to="/merchants/add" color="primary" class="ml-auto"><v-icon left> mdi-plus </v-icon> Add Merchant</v-btn>
        </v-app-bar>

        <v-container v-if="!isBusyMerchants" fluid class="pa-5">
            <div v-if="!hasCompleteGetStarted">
                <div class="get-started-label mb-5">
                    <h4>Get Started with QRTool</h4>
                </div>
                <v-row>
                    <v-col v-for="(details, i) in getStaredDetails" :key="i">
                        <GetStarted :details="details" />
                    </v-col>
                </v-row>
            </div>
            <v-row>
                <v-col>
                    <data-table />
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import GetStarted from '@/components/Merchant/GetStarted.vue';
import DataTable from '@/components/Merchant/DataTable.vue';

export default {
    name: 'Dashboard',
    components: {
        GetStarted,
        DataTable
    },
    data() {
        return {
            getStaredDetails: [
                {
                    id: 'add_merchant',
                    title: 'Add your first Merchants',
                    icon: 'add-merchant',
                    description: 'Import your list of merchants or manually add each merchant',
                    status: ''
                },
                {
                    id: 'send_qr',
                    title: 'Send QR via Email',
                    icon: 'send-qr',
                    description: 'Download the QR code direct to your computer or send the QR code directly to an email address',
                    status: ''
                },
                {
                    id: 'invite_users',
                    title: 'Invite Users',
                    icon: 'invite-user',
                    description: 'Invite new users to access and manage their own merchant and QR codes',
                    status: ''
                }
            ],
            isBusyMerchants: true
        };
    },
    computed: {
        hasCompleteGetStarted() {
            return this.achievementDetails.add_merchant == 'Completed' && this.achievementDetails.send_qr == 'Completed' && this.achievementDetails.invite_users == 'Completed';
        },
        userInfo() {
            return this.$store.getters['authentication/getUserInfo'];
        },
        achievementDetails() {
            return this.$store.getters['merchants/getAchievementDetails'];
        }
    },
    created() {
        this.initiate();
    },
    methods: {
        async initiate() {
            await this.getData();
            // await this.getData({
            //     index: 0,
            //     params: {
            //         'filters[actor_id]': this.userInfo.id,
            //         'filters[object_type]': 'merchants',
            //         'filters[action]': 'CREATED'
            //     }
            // });
            // await this.getData({
            //     index: 1,
            //     params: {
            //         'filters[actor_id]': this.userInfo.id,
            //         'filters[action]': 'EMAILED_MERCHANT_QR_CODE'
            //     }
            // });
            // await this.getData({
            //     index: 2,
            //     params: {
            //         'filters[actor_id]': this.userInfo.id,
            //         'filters[action]': 'INVITED_USER'
            //     }
            // });

            this.isBusyMerchants = false;
        },
        async getData(payload) {
            let { cancel_current_api_call } = payload || {};

            if (cancel_current_api_call) {
                this.$api.cancelCurrentApiCall();
            }

            await this.$store.dispatch('merchants/findMyAchievements');

            this.getStaredDetails[0].status = this.achievementDetails.add_merchant;
            this.getStaredDetails[1].status = this.achievementDetails.send_qr;
            this.getStaredDetails[2].status = this.achievementDetails.invite_users;

            // await this.$store
            //     .dispatch('auditTrails/fetchAuditTrailsUserAction', {
            //         config: {
            //             params
            //         }
            //     })
            //     .then((response) => {
            //         if (response && response.data.length > 0) {
            //             this.getStaredDetails[index]['status'] = 'Completed!';
            //             this.countCompletedGetStarted++
            //         } else {
            //             this.getStaredDetails[index]['status'] = 'Incomplete';
            //         }
            //     });
        }
    }
};
</script>

<style lang="scss" scoped>
.get-started-label {
    color: #16192c;
    font-weight: 500;
}
</style>
